import { render, staticRenderFns } from "./ClientEdit.vue?vue&type=template&id=2a3ff94b"
import script from "./ClientEdit.js?vue&type=script&lang=js&external"
export * from "./ClientEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports